import { render, staticRenderFns } from "./VerticalCardComingSoon.html?vue&type=template&id=f81113b2&scoped=true&external"
import script from "./VerticalCardComingSoon.vue?vue&type=script&lang=js"
export * from "./VerticalCardComingSoon.vue?vue&type=script&lang=js"
import style0 from "./VerticalCardComingSoon.scss?vue&type=style&index=0&id=f81113b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81113b2",
  null
  
)

export default component.exports